export { default } from './FooterLegal';
